<p class="text-primary-700 dark:text-primary-800">&copy; {{copyrightYears}} &mdash; {{copyrightHolder}} v{{version}}</p>
